"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _AdjustableTwoColumnGridModule = _interopRequireDefault(require("./../../scss/layout-wrappers/AdjustableTwoColumnGrid.module.scss"));
function AdjusableTwoColumnGrid({
  children,
  gap = '1.5rem',
  firstColumnWidth = 33,
  classname = ''
}) {
  const childrenList = _react.Children.toArray(children);
  return /*#__PURE__*/_react.default.createElement("adjustable-two-column-layout", {
    style: {
      '--atcl-gap-size': gap,
      '--atcl-first-column-width': typeof firstColumnWidth === 'string' ? firstColumnWidth : `${firstColumnWidth}%`
    },
    class: classname
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _AdjustableTwoColumnGridModule.default['two-column-layout__column-one']
  }, /*#__PURE__*/(0, _react.cloneElement)(childrenList[0], childrenList[0].props)), /*#__PURE__*/_react.default.createElement("div", {
    className: _AdjustableTwoColumnGridModule.default['two-column-layout__column-two']
  }, /*#__PURE__*/(0, _react.cloneElement)(childrenList[1], childrenList[1].props)));
}
var _default = exports.default = AdjusableTwoColumnGrid;